import React from "react";
import styled from "styled-components";
import CustomDoubleTitle from "../General/CustomDoubleTitle";
import { Collapse } from "antd";

const FaqSectionContainer = styled.div`
  width: 100%;
  background-color: #000e14;
  padding: 40px 0;
`;

const FaqSectionInnerContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;

  @media only screen and (max-width: 1430px) {
    max-width: 1250px;
  }
`;

const FaqSectionContentWrapper = styled.div`
  padding: 0;

  @media only screen and (max-width: 1280px) {
    padding: 0 10px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 30px;
  }

  @media only screen and (max-width: 942px) {
    padding: 0 15px;
  }
`;

const CollapseWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 30px;

  & .ant-collapse {
    width: 100%;
  }

  & .ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 1px solid #012534cc;
  }

  & .ant-collapse-header {
    background-color: transparent;
    color: #fff !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.5px;
  }

  & .ant-collapse-header-text {
    text-align: left;
  }

  & .ant-collapse-item-active {
    background-color: #012534;
  }

  & .ant-collapse-item.ant-collapse-item-active {
    border-bottom: none;
  }

  & .ant-collapse-item-active > .ant-collapse-header {
    color: #0fd4fb !important;
  }

  & .ant-collapse-content-box {
    padding: 16px !important;
  }

  @media only screen and (max-width: 600px) {
    background-color: transparent;
    color: #fff !important;
    font-size: 14px;
    font-weight: 400;
    line-height: 17.07px;
  }
`;

const CollapseInnerContent = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #d9d9d9;
  text-align: left;
`;

const FaqSection = () => {
  return (
    <FaqSectionContainer>
      <FaqSectionInnerContainer>
        <FaqSectionContentWrapper>
          <CustomDoubleTitle
            firstTitle={"FREQUENTLY ASKED QUESTIONS"}
            secondTitle={"FAQ"}
          />

          <CollapseWrapper>
            <Collapse
              bordered={false}
              expandIconPosition="end"
              size="large"
              items={[
                {
                  title: "Why do this instead of hiring a COO?",
                  content:
                    "Hiring a skilled COO takes months and costs *a ton* (average $121,000/yr). You're also on the hook for benefits + severance, and there's no guarantee they'll deliver what you want them to. Subscription models like ours are simply quantitatively & qualitatively better for the vast majority of companies under $3M/yr: you pay less, get results faster, and can pause or cancel your arrangement any time.",
                },
                {
                  title: "How much more cost-effective is this, really?",
                  content:
                    "When you take into account payroll, benefits, severance, and the opportunity cost of hiring, our service is ~30% of the price of hiring in-house, and ~70% of the price of hiring an agency. You also get access to two world-class ops executives that have helped scale several 8-figure companies, as well as a 100% satisfaction guarantee + the ability to pause or cancel anytime.",
                },
                {
                  title: "How does payment work?",
                  content:
                    "When you click one of the payment options above, you'll be taken to a Stripe Checkout page. After you pay, we'll automatically create a subscription for you that renews on the same day every month. You can cancel or pause at any time.",
                },
                {
                  title: "What do you mean by '100% satisfied'?",
                  content:
                    "Our project management flow includes a simple way to request changes or revisions after a delivery. If you're not completely satisfied with the systems you receive (think sales, hiring, onboarding, etc), you'd simply leave a comment and we'd continue revising your deliverable until you are.",
                },
                {
                  title: "How do I submit a request?",
                  content:
                    "After your thirty minute onboarding call, you'll receive access to your own ClickUp board, where you can view and manage ongoing projects. To create a request, you merely click the + button on your board and add the task to our queue directly.",
                },
                {
                  title: "What's your refund policy?",
                  content:
                    "If you're not 100% satisfied with your service, we'll keep working for free until you are.",
                },
                {
                  title: "What does 'unlimited' mean?",
                  content:
                    "You can submit an unlimited number of requests. Most clients often have 10-15 in the queue at any one time, and their board acts as a to-do list. Our team works on one at a time (prioritized by you), and our average turnaround time on a system deliverable is between 1-4 days. The moment we're done, we get to work on the next. In this way, we often deliver 10+ systems per month (whereas an in-house hire might deliver one or two).",
                },
                {
                  title: "How do we communicate?",
                  content:
                    "Vast majority of our comms are async, through Slack. Minimizing call-time provides much more flexibility, allowing us to deliver more projects and higher quality services. That said, we offer an optional weekly ops consultation to discuss bottlenecks, prioritize, and track progress.",
                },
              ].map((v, i) => {
                return {
                  key: `${i}`,
                  label: v.title,
                  children: (
                    <CollapseInnerContent>{v.content}</CollapseInnerContent>
                  ),
                };
              })}
              defaultActiveKey={[]}
            />
          </CollapseWrapper>
        </FaqSectionContentWrapper>
      </FaqSectionInnerContainer>
    </FaqSectionContainer>
  );
};

export default FaqSection;
